import axios from "axios";

// const UUID_STORAGE_KEY = "visitor_uuid";

const ipResponse = await axios.get("https://api.ipify.org?format=json");
const userData =
  ipResponse.data.ip +
  "||" +
  navigator.userAgent +
  "||" +
  window.location.href.replace(/^.*\/\/[^/]+/, "");

const axiosInstance = axios.create({
  baseURL: "/v1",
  timeout: 120000,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.feLog = btoa(userData);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
